import { render } from "./AddUserVideo.vue?vue&type=template&id=0ae2e888"
import script from "./AddUserVideo.vue?vue&type=script&lang=js"
export * from "./AddUserVideo.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\zoodkomak_tv_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__